import React, { useEffect, useState } from 'react';
import { stats } from '../mock';
import useReveal from '../hooks/useReveal';

function Counter({ value, suffix }) {
  const { ref, inView } = useReveal();
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const duration = 1600;
    const startTime = performance.now();
    const tick = (now) => {
      const p = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.floor(eased * value));
      if (p < 1) requestAnimationFrame(tick);
      else setN(value);
    };
    requestAnimationFrame(tick);
  }, [inView, value]);

  return (
    <span ref={ref}>{n.toLocaleString('en-IN')}{suffix}</span>
  );
}

export default function Stats() {
  return (
    <section className="py-16 bg-[#0B2447] relative overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-20" />
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="text-accent font-semibold uppercase tracking-wider text-sm">Our Mission</span>
          <p className="mt-3 text-lg lg:text-xl text-slate-200 italic">
            &ldquo;To deliver reliable, cost-effective and professional compliance solutions that help clients grow, stay compliant and succeed through quality service and long-term partnerships built on trust.&rdquo;
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-4xl lg:text-5xl font-extrabold text-white font-display">
                <Counter value={s.value} suffix={s.suffix} />
              </div>
              <div className="mt-2 text-sm text-slate-300">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
